
// Document Ready
document.addEventListener("DOMContentLoaded", () => {
    console.log("DOMContentLoaded");
    window.aplayer = document.getElementById('aplayer');
    if (window.aplayer != null) {
        window.aplayer.onended = function () {
            if (window.playAsPlaylist) {
                continuePlaylist();
            }
        };

        let audiolinks = document.querySelectorAll('[x-audio]');
        window.playlistIndex = 0;
        window.playlist = [];
        window.playlistElement = [];
        window.playlistByID = {};
        window.playlistMapAudioToEl = {};
        if (audiolinks.length > 0) {
            audiolinks.forEach((el) => {
                let asource = el.getAttribute('x-audio');
                window.playlist.push(asource);
                window.playlistElement.push(el);
                window.playlistMapAudioToEl[el.getAttribute('x-audio')] = el;
                window.playlistByID[el.getAttribute('x-audio-id')] = el.getAttribute('x-audio');
            })
        }
    }

    setInterval(showTime, 1000);
    setupTouch();
});

// Document
window.showUrl = function (url) {
    window.open(url).focus();
}

// Document
window.showDocument = function (file) {
    window.open("/storage/documents/" + file, '_document').focus();
}

window.showDocumentImages = function (id) {
    window.open("/document/show/" + id, '_document').focus();
}

// SONG ORDERING
window.getSongOrder = function () {
    let dragRoot = document.querySelector('[setlist-root]')
    let itemList = Array.from(
        dragRoot.querySelectorAll('[data-song-id]')
    ).map(songIds => ({
        id: songIds.getAttribute('data-song-id'),
        order: { setnumber: songIds.parentElement.getAttribute('data-setnumber') }
    }))

    return itemList;
}

// AUDIO
window.playDockedAudio = function (file,asPlaylist) {
    window.playlistIndex = window.playlist.indexOf(file);
    window.resetPlayingElement();
    window.elPlaying = window.playlistMapAudioToEl[file].parentElement.parentElement;
    window.hilightElement(window.playlistMapAudioToEl[file].parentElement.parentElement);
    if (asPlaylist != null) {
        window.playAsPlaylist = asPlaylist;
    }
    if (window.aplayer != null) {
        window.aplayer.src = "/storage/audio/" + file;
        window.aplayer.play();
        window.aplayer.parentNode.classList.remove('hidden');
    }
}
window.audioIsPlaying = function () {
    return window.aplayer
        && window.aplayer.currentTime > 0
        && !window.aplayer.paused
        && !window.aplayer.ended
        && window.aplayer.readyState > 2;
}

// PLAYLIST
window.startPlaylist = function () {
    if(!window.audioIsPlaying()){;
        window.resetPlayingElement();
        window.playFileAtIndex(window.playlistIndex);
    }
    window.playAsPlaylist = true;
    window.aplayer.parentNode.classList.remove('hidden');
}

window.playFileAtIndex = function (index) {
    if (window.aplayer != null && window.playlist.length != 0) {
        if (index < window.playlist.length) {
            window.aplayer.src = "/storage/audio/" + window.playlist[index];
            window.aplayer.play();
            window.highlightPlayingElement(index);
        } else {
            console.log("playListDone");
        }
    } else {
        console.log("error playFileAtIndex", window.aplayer, index, window.playlist.length);
    }
}

window.highlightPlayingElement = function(index){
    window.elPlaying =  window.playlistElement[index].parentElement.parentElement;
    window.hilightElement(elPlaying);
}

window.resetPlayingElement = function(){
    if(window.elPlaying!=undefined){
        window.resestHilightElement( window.elPlaying );
    }
}

window.resestHilightElement = function(el){
    el.classList.remove('border-2');
    el.classList.remove('border-dotted');
    el.classList.remove('border-yellow-500');
    el.classList.remove('p-4');
    el.classList.add('border-b');
    el.classList.add('border-gray-800');
}

window.hilightElement = function(el){
    el.classList.remove('border-b');
    el.classList.remove('border-gray-800');
    el.classList.add('border-2');
    el.classList.add('border-dotted');
    el.classList.add('border-yellow-500');
    el.classList.add('p-4');
}


window.continuePlaylist = function () {
    window.resetPlayingElement(window.playlistIndex);
    if (window.playlistIndex < window.playlist.length) {
        window.playlistIndex = window.playlistIndex + 1;
        window.playFileAtIndex(window.playlistIndex);
    }
}

window.showTime = function (e) {

    window.clockEl = document.getElementById("clock");
    if (window.clockEl == null) return;

    let time = new Date();
    let hour = time.getHours();
    let min = time.getMinutes();
    let sec = time.getSeconds();
    let am_pm = "AM";

    // // Setting time for 12 Hrs format
    // if (hour >= 12) {
    //     if (hour > 12) hour -= 12;
    //     am_pm = "PM";
    // } else if (hour == 0) {
    //     hr = 12;
    //     am_pm = "AM";
    // }

    hour = hour < 10 ? "0" + hour : hour;
    min = min < 10 ? "0" + min : min;
    sec = sec < 10 ? "0" + sec : sec;

    let currentTime = hour + ":" + min;// + ":" + sec;// + am_pm;
    let currentTimeSeconds = hour + ":" + min + ":" + sec;// + am_pm;

    // Displaying the time
    window.clockEl.innerHTML = currentTimeSeconds;
}


// TOUCH
function setupTouch() {
    document.addEventListener('mousedown', lock, false);
    document.addEventListener('touchstart', lock, false);

    document.addEventListener('mousemove', drag, false);
    document.addEventListener('touchmove', drag, false);

    document.addEventListener('mouseup', release, false);
    document.addEventListener('touchend', release, false);
}

var touchStartX = 0;
var touchStartY = 0;

function unify(e) { return e.changedTouches ? e.changedTouches[0] : e };

function lock(e) {
    touchStartX = e.clientX;
    touchStartY = e.clientY;
}

function drag(e) {}

function release(e) {
    e = unify(e);
    var difX = e.clientX - touchStartX;
    var difY = e.clientY - touchStartY;
    if( Math.abs(difX) > Math.abs(difY) ){
        console.log( difX < 0 ? "swipe left":"swipe right");
    }else{
        if( difY < 0 ){
            window.dispatchEvent( new CustomEvent('swipeup'));
        }else{
            window.dispatchEvent( new CustomEvent('swipedown'));
        }
       // console.log( difY < 0 ? "swipe up":"swipe down");
    }
}
